<template>
    <div class="newsNew-section-header">
<!--      <span class="spot"></span>-->
        <span class="module-title" >{{data.columnName || '未知'}}</span>
        <span class="module-more" @click="$emit('getMore', data.id)" v-if="showMore">更多
        <i class="el-icon-arrow-right" ></i>
        </span>
    </div>
</template>

<script>
    export default {
        name: "NewsHeader",

        props: {
            data: { type: Object, default:function(){
                    return {};
                }},
            showMore: { type: Boolean, default: true}

        },
        created() {



        },
        watch: {
            data(val){


            }
        }
    }
</script>

<style scoped lang="scss">
  @import "@/styles/variables.scss";
  .newsNew-section-header {
      padding: 25px 30px;
      display:flex;
    align-items: center;

    .spot {
      width: 4px;
      height: 20px;
      background: #0E6CCB;
      border-radius: 2px;
      margin-right: 7px;

    }
      .module-title {
          font-size: 24px;
          color: #333333;
        line-height: 34px;
        flex:1
      }
      .module-more {
          font-size: 14px;
          color: #666666;
        transition: $transition-common;
        &:hover {
          color:$color-primary;
          cursor: pointer;
        }
      }
  }
  @media (max-width: 1719px){
      .newsNew-section-header {
          .module-title {
              font-size: 20px;
          }
      }
  }
</style>